import { Link } from "react-router-dom";
import { fileUrl } from "../../lib/api";

export const SCHEMES = {
  blush: { bg: "#F9D6D2", fg: "#121212", accent: "#FFC72C", btn: "btn-cobalt" },
  paper: { bg: "#FAF8F5", fg: "#121212", accent: "#FF5A5F", btn: "btn-ink" },
  ink: { bg: "#121212", fg: "#FAF8F5", accent: "#FFC72C", btn: "btn-coral" },
  coral: { bg: "#FF5A5F", fg: "#121212", accent: "#121212", btn: "btn-ink" },
  cobalt: { bg: "#0047FF", fg: "#FFFFFF", accent: "#FFC72C", btn: "btn-coral" },
  yellow: { bg: "#FFC72C", fg: "#121212", accent: "#0047FF", btn: "btn-ink" },
};

export function Ticker({ text, testid = "hero-ticker" }) {
  const items = (text || "").split("·").map((x) => x.trim()).filter(Boolean);
  if (!items.length) return null;
  const row = [...items, ...items, ...items];
  return (
    <div className="bg-[#121212] text-[#FAF8F5] overflow-hidden border-y-2 border-[#121212]" data-testid={testid} aria-label={items.join(", ")}>
      <div className="ticker-track flex gap-10 py-3 whitespace-nowrap font-mono text-xs sm:text-sm uppercase tracking-[0.25em]" aria-hidden>
        {row.map((t, i) => <span key={i} className="flex items-center gap-10">{t}<span className="text-[#FFC72C]">✦</span></span>)}
      </div>
    </div>
  );
}

export default function HeroView({ hero, forceMobile = false }) {
  if (!hero) return null;
  const s = SCHEMES[hero.scheme] || SCHEMES.paper;
  const art = hero.artwork;
  const img = art?.image;
  const d = hero.desktop || {};
  const m = hero.mobile || {};
  const bg = hero.background_image;
  const mobileCls = forceMobile ? "" : "lg:hidden";
  const deskCls = forceMobile ? "hidden" : "hidden lg:block";
  const imgEl = (cfg, cls) => img && (
    <img src={fileUrl(img.url)} alt={img.alt || art.title} className={`absolute inset-0 w-full h-full ${cfg.fit === "cover" ? "object-cover" : "object-contain"} ${cls}`}
      style={{ objectPosition: cfg.position || "50% 50%", transform: cfg.zoom && cfg.zoom !== 1 ? `scale(${cfg.zoom})` : undefined }} fetchPriority="high" />
  );
  return (
    <>
      <section className="grain relative overflow-hidden" style={{ background: s.bg, color: s.fg }} data-testid="hero">
        {bg && <img src={fileUrl(bg.url)} alt="" aria-hidden className="absolute inset-0 w-full h-full object-cover opacity-25" />}
        <span aria-hidden className="absolute -left-10 top-24 h-40 w-40 rounded-full opacity-90" style={{ background: s.accent }} />
        <div className={`relative max-w-[1400px] mx-auto px-4 sm:px-8 py-10 ${forceMobile ? "" : "lg:py-20 lg:grid lg:grid-cols-12 lg:gap-12"} items-center`}>
          <div className={`${forceMobile ? "" : "lg:col-span-6"} relative z-10 fade-up`}>
            <h1 className="font-display uppercase text-5xl sm:text-6xl lg:text-7xl xl:text-[5.5rem] font-black tracking-[-0.02em] leading-[0.92]" data-testid="hero-headline">{hero.headline}</h1>
            {hero.subline && <p className="mt-6 text-base md:text-lg max-w-md font-medium" data-testid="hero-subline">{hero.subline}</p>}
            {hero.button_text && <Link to={hero.target || "/kunst"} className={`${s.btn} inline-flex items-center gap-3 h-14 px-8 mt-8 font-bold uppercase tracking-wider text-sm`} data-testid="hero-cta">{hero.button_text} <span aria-hidden>→</span></Link>}
          </div>
          <div className={`${forceMobile ? "mt-8" : "lg:col-span-6 mt-12 lg:mt-0"} relative`}>
            <div className="relative bg-[#FAF8F5] border-2 border-[#121212] shadow-[12px_12px_0_#121212]">
              <div className={`relative aspect-[4/5] ${mobileCls}`}>{imgEl(m, "p-3")}</div>
              <div className={`relative aspect-[4/5] max-h-[620px] w-full ${deskCls}`}>{imgEl(d, "p-4")}</div>
            </div>
            {hero.badge && <span className="absolute -top-5 -right-2 sm:-right-5 h-24 w-24 sm:h-28 sm:w-28 rounded-full bg-[#FFC72C] text-[#121212] border-2 border-[#121212] grid place-items-center text-center text-[11px] sm:text-xs font-black uppercase leading-tight p-3 rotate-[10deg]" data-testid="hero-badge">{hero.badge}</span>}
            {art && (
              <Link to={`/kunst/${art.slug}`} className="absolute -bottom-5 left-4 sm:left-8 bg-[#121212] text-[#FAF8F5] px-4 py-3 text-sm" data-testid="hero-artwork-credit">
                <span className="font-bold">{art.title}</span> · {art.artist}{art.year ? `, ${art.year}` : ""}
              </Link>
            )}
          </div>
        </div>
      </section>
      <Ticker text={hero.ticker} />
    </>
  );
}
